import { memo as Memo, useState, useRef, useMemo, useEffect } from 'react'
import { useRouter } from 'next/router'

//* GSAP
import gsap from 'gsap'

//* HOC
import withUIContext from 'context/consumerHOC/UIConsumer'

//* Helper
import { useActiveSection } from 'helpers'

//* Components
import Button from 'components/common/Button'
import Container from 'components/common/Container'
import CocktailCard from 'components/common/CocktailCard'

//* Style
import ListStyle from './style'

const List = Memo(({ data, winWidth, className, isGatesActive }) => {
    //! Router
    const router = useRouter()

    //! Refs
    const contRef = useRef()
    const cocktailItemRefs = useRef([])
    const cocktailItemImageRefs = useRef([])
    const itemsPerPage = useRef(3)

    //! States
    const [quantity, setQuantity] = useState(3)
    const activeSection = useActiveSection(contRef, 90)

    //!  News items
    const cocktailItems = useMemo(() => {
        return data.map((item, index) => {
            if (index < quantity * itemsPerPage.current) {
                return (
                    <div
                        key={index}
                        className={`cocktail-item col-4 col-ts-6 col-m-12`}
                    >
                        <CocktailCard
                            name={item.name}
                            time={item.time}
                            image={item.featured_image}
                            url={`/cocktails/${item.slug}`}
                            ref={(ref) => {
                                cocktailItemRefs.current[index] = ref?.contRef
                                cocktailItemImageRefs.current[index] = ref?.imageRef
                            }}
                        />
                    </div>
                )
            }
        })
    }, [data, winWidth, quantity, itemsPerPage.current, cocktailItemRefs.current, cocktailItemImageRefs.current])

    //! Animation
    useEffect(() => {
        const arr1 = [...cocktailItemRefs.current]
        const arr2 = [...cocktailItemImageRefs.current]

        //! Array for animations
        const arr1ForAnim = quantity !== 3 ? arr1.slice(-itemsPerPage.current) : arr1
        const arr2ForAnim = quantity !== 3 ? arr2.slice(-itemsPerPage.current) : arr2

        gsap.killTweensOf([arr1ForAnim, arr2ForAnim])

        if (activeSection && !isGatesActive) {
            gsap.to(arr1ForAnim, { duration: 1, stagger: 0.1, y: '0%', ease: 'power2.out' })
            gsap.to(arr2ForAnim, { delay: 0.2, stagger: 0.1, duration: 0.7, borderRadius: activeSection ? `${winWidth <= 1024 ? 16 : 24}px` : `60%`, ease: 'power2.out' })
        }
    }, [activeSection, winWidth, router.asPath, quantity, itemsPerPage.current, isGatesActive])

    //! Load more function
    const loadMore = () => {
        setQuantity(quantity + 1)
    }

    return (
        <ListStyle
            ref={contRef}
            className={className || ''}
        >
            <Container>
                <Container
                    row
                    full
                    className={`cocktails-content-wrap`}
                >
                    {cocktailItems}
                </Container>

                {quantity * itemsPerPage.current < data.length && (
                    <div className={`load-more-btn-wrap`}>
                        <Button
                            btnType={'with-bg-transparent'}
                            text={`loadMore`}
                            onClick={loadMore}
                        />
                    </div>
                )}
            </Container>
        </ListStyle>
    )
})

export default withUIContext(List, ['winWidth', 'isGatesActive'])
